import cookieStore from './cookie';

declare global {
  interface Window {
    flutter_inappwebview?: {
      callHandler?: (handler: string, data: { action: string; data: unknown }) => void;
    };
  }
}

interface MobAppCookieData {
  _appVersion?: string;
  _osName?: string;
}

interface FlutterEvent {
  eventName: string;
  data: unknown;
}

const MOB_COOKIE_NAME = 'pb-mob-app';

const getCookieData = (): MobAppCookieData => {
  const cookieValue = cookieStore.get(MOB_COOKIE_NAME);
  if (!cookieValue) {
    return {};
  }

  try {
    const parsed: unknown = JSON.parse(cookieValue);

    return typeof parsed === 'object' && parsed !== null ? (parsed as MobAppCookieData) : {};
  } catch {
    return {};
  }
};

// Better to use this method for detect WebView
export const isWebView = (): boolean => {
  return !!cookieStore.get(MOB_COOKIE_NAME);
};

export const isWebViewFlutter = (): boolean => {
  return isWebView() && window.flutter_inappwebview !== undefined;
};

export const getMobAppVersion = (): string | null => {
  if (!isWebView()) {
    return null;
  }

  return getCookieData()._appVersion ?? null;
};

export const isPaybisAndroidApp = (): boolean => {
  return isWebView() && getCookieData()._osName === 'Android';
};

export const isPaybisAppleApp = (): boolean => {
  return isWebView() && getCookieData()._osName === 'iOS';
};

let isFlutterReady = false;
const flutterEventQueue: FlutterEvent[] = [];
const sendFlutterEvent = (flutterEvent: FlutterEvent): void => {
  const flutterWebView = window.flutter_inappwebview;

  if (!flutterWebView || !flutterWebView.callHandler) {
    return;
  }
  
  flutterWebView.callHandler('WebViewJSHandler', {
    action: flutterEvent.eventName,
    data: flutterEvent.data,
  });
};
export const emitMobAppEvent = (eventName: string, data: unknown = {}): void => {
  if (!isWebView()) return;

  if (isFlutterReady) {
    sendFlutterEvent({ eventName, data });
  } else {
    flutterEventQueue.push({ eventName, data });
  }
};

if (typeof window !== 'undefined') {
  window.addEventListener(
    'flutterInAppWebViewPlatformReady',
    () => {
      isFlutterReady = true;

      flutterEventQueue.forEach(flutterEvent => sendFlutterEvent(flutterEvent));
    },
    { once: true },
  );
}

